const $ = require('jquery');
$.noConflict();
$.DataTable = require('datatables.net');
import WithSystem from './../service/WithSystem';
export default class LeanerScomTbl extends React.Component{
  constructor(props) {
    super(props);
    this.tablerender = null;
  }
  componentDidMount() {
    this.leanerScormreportrender();
  }
  leanerScormreportrender = () => {
    this.tablerender = $(this.refs.main1).DataTable({
      "lengthMenu": [window.showlimit],
      "lengthChange": false,
      "bFilter": false,
      "stateSave": false,
      "scrollX": true,
      "ordering": true,
      autoWidth: false,
      "columnDefs": [
        // { className: "center-left", targets: [0, 1, 2, 3, 4, 5] },
      ],
      "order": [[0, "asc"]],
      "processing": true,
      "serverSide": true,
      ajax: {
        type: "POST",
        data: { 'learnerid': this.props.learnerid, 'learnerCourseid': this.props.learnerCourseid },
        beforeSend: function () {
          $("#progress-filter-loading").addClass("show");
        },
        url: admin_url + 'Consolidate_reports/learners_scorm_report'+__setSsAuthUrl,
        "dataSrc": function (response) {
          $("#progress-filter-loading").removeClass("show");
          return response.aaData;
        },
      },
      'columns': [
        {
          "mRender": function (data, type, row) {
            return `${row.name}`;
          }
        },
       /* {
          "mRender": function (data, type, row) {
            if (row.status == 1) {
              return `<span class="leaner-grade grade-success">Graded</span>`;
            } else {
              return `<span class="leaner-grade grade-no-success">Not Graded</span>`;
            }
          }
        },*/
        {
          "mRender": function (data, type, row) {
            if (row.complete_date != ""  && row.complete_date != null  && row.progress == 100){
              var formateed_date = formatAMPM(changeDatesFormat(convertUTCtoLocalTime(row.complete_date)));
              return `${formateed_date}`;
            }else{
              return `-`;
            }
          }
        },
        {
          "mRender": function (data, type, row) {
            if (row.time_spent != null){
              // var formateed_date = formatAMPM(changeDatesFormat(convertUTCtoLocalTime(row.complete_date)));
              
              return `${secondsToHmsScorm(row.time_spent)}`;
            }else{
              return `-`;
            }
          }
        },
        // {
        //   "mRender": function (data, type, row) {
        //     var cs_percentage    = row.progress;
        //     var percentageColour = '#ff6466';
        //     if (cs_percentage <= 20) {
        //       percentageColour = '#ff6466';
        //     } else if (cs_percentage >= 21 && cs_percentage <= 40) {
        //       percentageColour = '#ff929E';
        //     } else if (cs_percentage >= 41 && cs_percentage <= 60) {
        //       percentageColour = '#fcde88';
        //     } else if (cs_percentage >= 61 && cs_percentage <= 80) {
        //       percentageColour = '#61dea9';
        //     } else if (cs_percentage >= 81 && cs_percentage <= 100) {
        //       percentageColour = '#4ebe6d';

        //     }
        //     return `<div class="d-flex w-60 align-center">
        //                             <div class="leaner-progress-bar">
        //                             <div class="leaner-progress-percent" percent="${cs_percentage}" style="background-color: ${percentageColour}; width: ${cs_percentage}%;"></div>
        //                         </div>
        //                         <span>${cs_percentage}%</span>
        //                     </div>`;
        //   }
        // },        
      ],
      "language": {
        "emptyTable": innernoMsg
      },
      "drawCallback": function (settings) {
      },
    });
  }
  componentDidUpdate(prevProps) {
    /*  if ((this.props.queryFilter.selectedCourse !== prevProps.filters.selectedCourse) || (this.props.queryFilter.startdate !== prevProps.filters.startdate) || (this.props.queryFilter.searchkey !== prevProps.queryFilter.searchkey) || (this.props.queryFilter.comstartdate !== prevProps.queryFilter.comstartdate)) {
       $('#myTable').DataTable().destroy();
       this.overallreportrender();
     } else {
       if (JSON.stringify(this.props.filters.contentDisplay) !== JSON.stringify(prevProps.filters.contentDisplay)) {
         this.contentColumnDisplay();
       }
     }*/
  }

  componentWillUnmount() {
    $('#table_id1').DataTable().destroy();
    $('#myTable').DataTable().destroy();
    $('.data-table-wrapper')
      .find('table')
      .DataTable()
      .destroy(true);
  }
  render() {
    return (<div>
      <table className="display" width="100%" id="table_id1" ref="main1">
        <thead>
          <tr>
            <th className="no-sort">Scorm Name</th>
            {/*<th className="no-sort">Status</th>*/}
            <th className="no-sort">Completion Date</th>
            <th className="no-sort">Time Spent</th>

            {/* <th className="no-sort">Scorm Progress</th> */}
          </tr>
        </thead>
      </table>
    </div>)
  }
}